export const FETCH_LOGIN_DETAILS = "FETCH_LOGIN_DETAILS";
export const FETCH_LOGIN_DETAILS_SUCCESS = "FETCH_LOGIN_DETAILS_SUCCESS";
export const FETCH_LOGIN_DETAILS_FAILURE = "FETCH_LOGIN_DETAILS_FAILURE";

export const FETCH_UNREGISTERED_EMPLOYEES = "FETCH_UNREGISTERED_EMPLOYEES";
export const FETCH_UNREGISTERED_EMPLOYEES_SUCCESS = "FETCH_UNREGISTERED_EMPLOYEES_SUCCESS";
export const FETCH_UNREGISTERED_EMPLOYEES_FAILURE = "FETCH_UNREGISTERED_EMPLOYEES_FAILURE";

export const CREATE_LOGIN_USER_REQUEST = "CREATE_LOGIN_USER_REQUEST";
export const CREATE_LOGIN_USER_SUCCESS = "CREATE_LOGIN_USER_SUCCESS";
export const CREATE_LOGIN_USER_FAILURE = "CREATE_LOGIN_USER_FAILURE";

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const TOGGLE_USER_STATUS_REQUEST = 'TOGGLE_USER_STATUS_REQUEST';
export const TOGGLE_USER_STATUS_SUCCESS = 'TOGGLE_USER_STATUS_SUCCESS';
export const TOGGLE_USER_STATUS_FAILURE = 'TOGGLE_USER_STATUS_FAILURE';

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const FETCH_ROLES_REQUEST = "FETCH_ROLES_REQUEST";
export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE";

export const FETCH_ACCESS_RIGHTS_REQUEST = "FETCH_ACCESS_RIGHTS_REQUEST";
export const FETCH_ACCESS_RIGHTS_SUCCESS = "FETCH_ACCESS_RIGHTS_SUCCESS";
export const FETCH_ACCESS_RIGHTS_FAILURE = "FETCH_ACCESS_RIGHTS_FAILURE";

export const SAVE_ROLE_ACCESS_RIGHTS_REQUEST = 'SAVE_ROLE_ACCESS_RIGHTS_REQUEST';
export const SAVE_ROLE_ACCESS_RIGHTS_SUCCESS = 'SAVE_ROLE_ACCESS_RIGHTS_SUCCESS';
export const SAVE_ROLE_ACCESS_RIGHTS_FAILURE = 'SAVE_ROLE_ACCESS_RIGHTS_FAILURE';

export const FETCH_MODULES_REQUEST = "FETCH_MODULES_REQUEST";
export const FETCH_MODULES_SUCCESS = "FETCH_MODULES_SUCCESS";
export const FETCH_MODULES_FAILURE = "FETCH_MODULES_FAILURE";

export const SAVE_MODULE_REQUEST = "SAVE_MODULE_REQUEST";
export const SAVE_MODULE_SUCCESS = "SAVE_MODULE_SUCCESS";
export const SAVE_MODULE_FAILURE = "SAVE_MODULE_FAILURE";

export const DELETE_MODULE_REQUEST = "DELETE_MODULE_REQUEST";
export const DELETE_MODULE_SUCCESS = "DELETE_MODULE_SUCCESS";
export const DELETE_MODULE_FAILURE = "DELETE_MODULE_FAILURE";

export const FETCH_CONFIGURATION_SETUP_REQUEST = "FETCH_CONFIGURATION_SETUP_REQUEST";
export const FETCH_CONFIGURATION_SETUP_SUCCESS = "FETCH_CONFIGURATION_SETUP_SUCCESS";
export const FETCH_CONFIGURATION_SETUP_FAILURE = "FETCH_CONFIGURATION_SETUP_FAILURE";

export const SAVE_CONFIGURATION_SETUP_REQUEST = "SAVE_CONFIGURATION_SETUP_REQUEST";
export const SAVE_CONFIGURATION_SETUP_SUCCESS = "SAVE_CONFIGURATION_SETUP_SUCCESS";
export const SAVE_CONFIGURATION_SETUP_FAILURE = "SAVE_CONFIGURATION_SETUP_FAILURE";